import { CountryAbbreviationPipe } from './../../pipes/country.pipe';
import { MemberDashboard } from './../../models/ss-api/responses/member.dashboard.response';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AddCreditCardRequest } from '../../models/ss-api/requests/add.credit.card.request';
import { BaseResponse } from '../../models/comm-http/responses/BaseResponse';
import { Router } from '@angular/router';
import { CreditCardValidator } from 'angular-cc-library';
import { formControlBinding } from '@angular/forms/src/directives/ng_model';

export interface IAddCreditCardDialogModel {
    title: string;
    subTitle: string;
    message: string;
    MemberID: number;
    Member: MemberDashboard
}


@Component({
    selector: 'add-credit-card-dialog',
    styleUrls: ['./add.credit.card.dialog.css'],
    templateUrl: './add.credit.card.dialog.html',
    providers: [CountryAbbreviationPipe]
})
export class AddCreditCardDialog extends DialogComponent<IAddCreditCardDialogModel, boolean> implements IAddCreditCardDialogModel, OnInit {

    @ViewChild('ccNumber') ccNumber;

    title: string;
    subTitle: string;
    message: string;
    MemberID: number;
    Member: MemberDashboard;

    CreditCardForm: FormGroup;

    Year: number = new Date().getFullYear();
    YearRange: any[] = [];
    // CC Name Variables
    ccFirstName = '';
    ccLastName = '';
    ccardType: number;

    // dialog confirm add creditcard
    Add_Confirm_Title: string = 'Add New Credit Card?';
    Add_Confirm_Text: string = 'You are about to add a new Credit Card.';

    // dialog added info
    Add_Added_Title: string = 'Saved!';
    Add_Added_Text: string = 'New Credit Card Saved.';
    Add_Added_Timeout: number = 1500;

    constructor(private api: ssApiService, dialogService: DialogService, private sweetAlertService: SweetAlertService, private countryAbbrev: CountryAbbreviationPipe, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {

        this.CreditCardForm = new FormGroup({
            'ccNameOnCard': new FormControl('', [Validators.required]),
            'ccNr': new FormControl('', [<any>CreditCardValidator.validateCCNumber, Validators.required, Validators.maxLength(22), Validators.minLength(13), Validators.pattern('^[0-9 \+\-\]+$')]),
            'ccExpMonth': new FormControl('01', [Validators.required]),
            'ccExpYear': new FormControl(this.Year, [Validators.required]),
            'zipCode': new FormControl('', [Validators.required]),
            'cvv': new FormControl('', [Validators.required, Validators.minLength(3)]),
            'ccMakeDefault': new FormControl(true),

        });

        // SET UP YEAR DROPDOWN
        for (let i: number = 0; i < 21; i++) {
            this.YearRange.push(this.Year + i);
        }

        this.SetupMemberDetails();

        let disposable = this.CreditCardForm.valueChanges.subscribe(response => {
            const classes = this.ccNumber.nativeElement.className;
            if (classes.includes('visa')) {
                this.ccardType = 1;
            } else if (classes.includes('mastercard')) {
                this.ccardType = 2;
            } else if (classes.includes('discover')) {
                this.ccardType = 3;
            } else if (classes.includes('amex')) {
                this.ccardType = 4;
            }
        });
    }

    SetupMemberDetails() {
        let controls = this.CreditCardForm.controls;

        controls.ccNameOnCard.setValue(this.Member.FirstName + ' ' + this.Member.LastName);
        controls.zipCode.setValue(this.Member.Zip);
    }

    hasLastName(): boolean {

        let ccNameOnCard = this.CreditCardForm.get('ccNameOnCard').value;
        this.getNameOnCard(ccNameOnCard);
        if (this.ccLastName == '')
            return false;

        return true;

    }

    getNameOnCard(nameString: string) {

        this.ccFirstName = '';
        this.ccLastName = '';

        let namesSplit = nameString.split(' ');

        if (namesSplit.length == 0)
            return;

        let firstName = namesSplit[0];

        let lastName = '';

        if (namesSplit.length > 1) {
            for (let i = 1; i < namesSplit.length; i++) {
                if (i != 1)
                    lastName += ' ';

                lastName += namesSplit[i];
            }
        }

        this.ccFirstName = firstName;
        this.ccLastName = lastName;

    }



    async confirm() {

        this.getNameOnCard(this.CreditCardForm.controls.ccNameOnCard.value);
        // check card is valid
        let ccNr = this.CreditCardForm.controls.ccNr.value;

        // extract expiration month and year
        let expMonth = this.CreditCardForm.controls.ccExpMonth.value;
        let expYear = this.CreditCardForm.controls.ccExpYear.value;

		let firstName = this.ccFirstName;
        let lastName = this.ccLastName;

		let address1 = this.Member.Address1;
        let city = this.Member.City;
        let country = this.Member.Country;
        let zipCode = this.CreditCardForm.controls.zipCode.value;
        let state = this.Member.State;
        let cvv = this.CreditCardForm.controls.cvv.value;
		
		
        let isDefault = this.CreditCardForm.controls.ccMakeDefault.value;

        // MAKE SURE CARD ISN"T EXPIRED
        let currentYear = new Date().getFullYear();
        let currentMonth = new Date().getMonth();
        if (expYear < currentYear || (expYear == currentYear && expMonth < currentMonth)) {
            this.sweetAlertService.swal({
                title: 'This Card Has Expired!',
                text: 'Make sure to provide a credit card with a valid expiration date',
                type: 'error',
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: 'OK',
            })
                .then(() => { }, () => { }); // keep this line to prevent promise error;
            return;
        }


        // put date in request
        let newCard = new AddCreditCardRequest();

        newCard.Address01 = address1;
        newCard.City = city;
        newCard.Country = country;
        newCard.CreditCardNumber = ccNr.replace(/\s+/g, '');
        newCard.CVV = 0;
        newCard.ExpMonth = Number.parseInt(expMonth);
        newCard.ExpYear = Number.parseInt(expYear);
        newCard.State = state;
        newCard.FirstName = firstName;
        newCard.LastName = lastName;
        newCard.ZipCode = zipCode;
        newCard.CVV = cvv;

        if (isDefault == '')
            newCard.SetAsDefault = false;
        else
            newCard.SetAsDefault = isDefault;

        newCard.MemberID = this.MemberID;

        // confirm
        this.sweetAlertService.swal({
            title: this.Add_Confirm_Title,
            text: this.Add_Confirm_Text,
            type: 'warning',
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Yes, add!',
            cancelButtonText: 'No, cancel',
            allowOutsideClick: false,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                // addcard
                return this.api.AddCreditCard(newCard).toPromise()
            }
        })
            .then(
                async (response: BaseResponse<AddCreditCardRequest>) => {

                    if (!response.Result) {
                        // error

                        console.log(response);

                        var title = "Error";
                        var message = response.Message; // "Error adding credit card";
    
                        if (response.Message.includes("Zip Code")){
                            title = "Zip Code Error";
                            message = "Wrong Zip Code for this card.";
                        }
                        else if (response.Message.includes("CVC")){
                            title = "CVC Error";
                            message = "Wrong CVC Security code for this card.";
                        }

                        this.sweetAlertService.swal(
                            {
                                title: title,
                                text: message,
                                type: 'error',
                                showCancelButton: true,
                                showConfirmButton: false,
                            })
                            .then(() => { }, () => { }); // keep this line to prevent promise error;
                        return;
                    }


                    // show confirmation
                    this.sweetAlertService.swal(
                        {
                            title: this.Add_Added_Title,
                            text: this.Add_Added_Text,
                            type: 'success',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: this.Add_Added_Timeout
                        })
                        .then(() => {

                        }, () => { }); // keep this line to prevent promise error;

                    this.close();
                },
                (dismiss) => {
                    if (dismiss === 'cancel') {

                        if (!confirm)
                            return;

                        // show cancelled
                        this.sweetAlertService.swal({
                            title: 'Cancelled',
                            text: 'No changes are saved.',
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1000
                        }).then(() => {
                            this.close();
                        }, () => { }); // keep this line to prevent promise error;
                    }
                }).catch(error => {
                    this.sweetAlertService.swal(
                        {
                            title: 'Error',
                            text: error.message,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true,
                            confirmButtonText: 'OK',
                        })
                        .then((response: any) => {
                            this.result = false;
                            // this.IsBusy = false;
                            this.close();
                        }, (dismiss) => {
                            // this.IsBusy = false;
                            return;
                        }); // keep this line to prevent promise error;
                });

    }

}
